module.exports = __webpack_public_path__ + "img/overview-report.f491d1d.png";